var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grade-percent"},[_c('canvas',{attrs:{"id":'canvas'+_vm.id}}),_vm._v(" "),_c('span',{attrs:{"id":'score'+_vm.id}},[_vm._v(_vm._s(_vm.score))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cf4bcb5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/cmpnt/CanvasScore/CanvasScore.vue
// module id = null
// module chunks = 